export default {"src":"/_next/static/media/0x8f1f15dcf4c70873faf1707973f6029dec4164b3.f90b4582.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};